module.exports = window.wp?.plugins;